module.exports = __webpack_public_path__ + "assets/media/login.8729149c.mp4";